// extracted by mini-css-extract-plugin
module.exports = {"container":"e_i3","title":"e_j3","titleIcon":"e_k3","summary":"e_l3","sourcesTitle":"e_m3","sources":"e_n3","source":"e_o3"};